import * as yup from 'yup';
import * as regex from '../../../utils/constants/regex';

export const deliveryPartnerFormSchema = yup.object({
  name: yup.string().required('Name is required'),
  email: yup
    .string()
    .transform((value) =>
      value === '' ? undefined : value
    )
    .matches(regex.EMAIL, 'Please enter a valid email'),
  number: yup
    .string()
    .required('Mobile Number is required')
    .length(10, 'Please enter valid number')
    .matches(
      regex.MOBILE_NUMBER,
      'Please enter valid number'
    ),
  company: yup.array().required('Company is required'),
  plant: yup.array(),
  altNumber: yup
    .string()
    .matches(
      regex.MOBILE_NUMBER,
      'Please enter valid number'
    ),
  commission: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === '' ? null : value
    )
    .nullable()
    .typeError('Commission must be a numeric value')
    .min(0, 'Commission must be a non-negative value'),
});

export type TDeliveryPartnerFormData = yup.InferType<
  typeof deliveryPartnerFormSchema
>;
